import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { delay, distinctUntilChanged, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TaskService {
  private tasks = [];
  private taskObservor = new Subject<any>();

  constructor() {}

  resetTasks() {
    this.tasks = [];
  }

  setTask(task: Observable<any>): Observable<any> {
    this.tasks.push(false);

    const index = this.tasks.length - 1;
    return task.pipe(
      tap(() => {
        this.tasks[index] = true;
        this.taskObservor.next(this.tasks.every(task => task));
      })
    );
  }

  onTasksComplete() {
    return this.taskObservor.pipe(
      distinctUntilChanged(),
      delay(500)
    );
  }
}
